import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=00df5c23&scoped=true&"
import script from "./Course.js?vue&type=script&lang=js&"
export * from "./Course.js?vue&type=script&lang=js&"
import style0 from "./Course.scss?vue&type=style&index=0&id=00df5c23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df5c23",
  null
  
)

export default component.exports